<template>
	<Transition name="fade" appear mode="out-in">
		<slot></slot>
	</Transition>
</template>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 200ms ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>